import { SVGAttributes } from 'react';
import * as React from 'react';

export const AbstractFileIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 4.3335C4 2.67664 5.34315 1.3335 7 1.3335H20L28 9.3335V27.6668C28 29.3237 26.6569 30.6668 25 30.6668H7C5.34315 30.6668 4 29.3237 4 27.6668V4.3335Z"
        fill="url(#paint0_linear_2067_11684)"
      />
      <path d="M23 9.3335H28L20 1.3335V6.3335C20 7.99035 21.3431 9.3335 23 9.3335Z" fill="#D2D2DB" />
      <defs>
        <linearGradient
          id="paint0_linear_2067_11684"
          x1="16"
          y1="1.3335"
          x2="16"
          y2="30.6668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F5" />
          <stop offset="1" stopColor="#C8C8CC" />
        </linearGradient>
      </defs>
    </svg>
  );
};
